import { useCallback } from 'react';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { Actions, Events } from '../../../../Account/util/analytics';
import history from '../../../../../core/history';

export const useGoToAccountSettings = (onClose: any) => {
  return useCallback(() => {
    onClose();
    analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
      action: Actions.PROFILE_SELECTOR,
      label: 'Touch Settings',
    });
    history.push('/account/settings');
  }, [onClose]);
};
